import { Trans } from '@lingui/macro';
import { observer } from 'mobx-react-lite';
import React, { FC, useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Context } from '../..';
import { ModalPopoverRightTop } from '../pages/modal/modal-popover-rt';
import { PrivPolModal } from './PrivacyPolicyModal';
import { urlLE } from '../../appConfig';


const Lang: FC = () => {

    const { store } = useContext(Context);

    return (
        <div>
            <table className="table">
                <tbody style={{ cursor: "pointer" }}>
                    <tr onClick={() => store.setLang("ba")}>
                        <td>Башҡортса</td>
                    </tr>
                    <tr onClick={() => store.setLang("ru")}>
                        <td>Русский</td>
                    </tr>
                    <tr onClick={() => store.setLang("en")}>
                        <td>English</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};


const LoginForm: FC = () => {
    const [email, setEmail] = useState<string>('');
    const [name, setName] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [spec, setSpec] = useState<boolean>(false);
    const [consent, setConsent] = useState<boolean>(false);
    const [privPolModal, setPrivPolModal] = useState<boolean>(false);
    const [page, setPage] = useState(1);
    const [langToggle, setLangToggle] = useState<boolean>(false);
    const { store } = useContext(Context);
    const navigate = useNavigate();
    const [see, setSee] = useState(false);


    if (document.getElementById('password') as HTMLInputElement) {
        if (see) {
            (document.getElementById('password') as HTMLInputElement).type = 'text'
        } else {
            (document.getElementById('password') as HTMLInputElement).type = 'password'
        }
    }


    const registration = () => {
        if (consent) {
            if (spec) {
                store.specRegistration({ email, name, password });
            } else {
                store.registration({ email, name, password });
            }
        } else {
            alert(store.lang === 'ba' ? 'Шәхси мәғлүмәттәрҙе эшкәртеүгә рөхсәт бирмәнегеҙ. Беҙ һеҙҙе теркәй алмайбыҙ.' : store.lang === 'ru' ? 'Вы не дали разрешения на обработку персональных данных. Мы не можем вас зарегистрировать.' : 'You have not given permission for the processing of personal data. We can\'t register you.')
        };
    };

    return (<>
        <div className="row justify-content-end">
            <div className="col-2">
                <Link className="nav-link text-dark" to="" onClick={() => setLangToggle(true)}><i className='icon dark-language' /><Trans>English</Trans></Link>
            </div>
        </div>

        <div className="row justify-content-center">
            <div className="col-2">
                <Link className="nav-link text-light" to="/">
                    <img src='/images/morb.png' alt='logo' className='login-form-logo' />
                </Link>
            </div>
        </div>

        {store.regProccess ?
            <div className='row justify-content-center mt-5 pb-3'><Trans>Please wait for the registration process to complete</Trans></div>
            :
            <>
                <div className='row justify-content-center mt-5 pb-3'>
                    <div className='col-12 col-md-6'>
                        <ul className="nav nav-tabs justify-content-center cursor-pointer">
                            <li className="nav-item">
                                <span className={"nav-link" + (page === 1 ? "  active" : "")} onClick={() => setPage(1)} ><Trans>Authorization</Trans></span>
                            </li>
                            <li className="nav-item">
                                <span className={"nav-link" + (page === 2 ? "  active" : "")} onClick={() => setPage(2)} ><Trans>Registration</Trans></span>
                            </li>
                            <li className="nav-item">
                                <span className="nav-link"><a style={{textDecoration: "none"}} href={urlLE}><Trans>LE Authorization</Trans></a></span>
                            </li>
                            <li className="nav-item">
                                <span className="nav-link"><a style={{textDecoration: "none"}} href={urlLE + "reg"}><Trans>LE Registration</Trans></a></span>
                            </li>
                        </ul>
                    </div>
                </div>

                {page === 1 ?
                    <form className='row'>
                        <div className='mb-4 row justify-content-center'>
                            <label className="form-label col-3 col-md-1"><Trans>Email</Trans></label>
                            <div className="col-7 col-md-3">
                                <input
                                    type="email"
                                    className="form-control"
                                    onChange={e => setEmail(e.target.value)}
                                    value={email}
                                    placeholder='login@host.com'
                                />
                            </div>
                        </div>
                        <div className='mb-4 row justify-content-center'>
                            <label className="form-label col-3 col-md-1"><Trans>Password</Trans></label>
                            <div className="col-7 col-md-3 d-flex">
                                <input
                                    id='password'
                                    className="form-control"
                                    onChange={e => setPassword(e.target.value)}
                                    value={password}
                                />
                                <div style={{ position: 'relative' }}><i className={'icon' + (see ? ' see' : ' unsee') + ' absolute'} onClick={() => setSee(!see)} /></div>
                            </div>
                        </div>
                        <div className='mb-4 row justify-content-center'>
                            <label className="form-label col-3 col-md-1"></label>
                            <div className="col-7 col-md-3 d-flex">
                                <Link className="nav-link text-primary" to="/reset_pass"><Trans>Forgot your password?</Trans></Link>
                            </div>
                        </div>
                        <div className='row justify-content-center'>
                            <div className="col-6 col-md-2">
                                <button
                                    type="button"
                                    className="btn btn-primary w-100"
                                    onClick={() => {
                                        store.login(email, password);
                                        if (store.refFrom === '' || store.refFrom.indexOf('/reset') === 0) {
                                            navigate('/');
                                        } else {
                                            navigate(-1);
                                        };
                                    }}
                                ><Trans>Log in</Trans></button>
                            </div>
                        </div>
                    </form>
                    :
                    <form>
                        <div className='mb-4 row justify-content-center'>
                            <label className="form-label col-3 col-md-2"><Trans>Email</Trans></label>
                            <div className="col-7 col-md-3">
                                <input
                                    type="email"
                                    className="form-control"
                                    onChange={e => setEmail(e.target.value)}
                                    value={email}
                                    placeholder='login@host.com'
                                />
                            </div>
                        </div>
                        <div className='mb-4 row justify-content-center'>
                            <label className="form-label col-3 col-md-2"><Trans>Your name</Trans></label>
                            <div className="col-7 col-md-3">
                                <input
                                    type="name"
                                    className="form-control"
                                    onChange={e => setName(e.target.value)}
                                    value={name}
                                />
                            </div>
                        </div>
                        <div className='mb-4 row justify-content-center'>
                            <label className="form-label col-3 col-md-2"><Trans>Password</Trans></label>
                            <div className="col-7 col-md-3 d-flex">
                                <input
                                    id='password'
                                    className="form-control"
                                    onChange={e => setPassword(e.target.value)}
                                    value={password}
                                />
                                <div style={{ position: 'relative' }}><i className={'icon' + (see ? ' see' : ' unsee') + ' absolute'} onClick={() => setSee(!see)} /></div>

                            </div>
                        </div>
                        <div className='mb-4 row justify-content-center'>
                            <label className="form-label col-3 col-md-2"><Trans>Register as specialist</Trans></label>
                            <div className="col-7 col-md-3">
                                <input
                                    type="checkbox"
                                    checked={spec}
                                    className="form-check-input"
                                    onChange={() => setSpec(!spec)}
                                />
                            </div>
                        </div>
                        <div className='mb-4 row justify-content-center'>

                            <div className="col-10 col-md-5 d-flex">
                                <input
                                    type="checkbox"
                                    checked={consent}
                                    className="form-check-input"
                                    onChange={() => setConsent(!consent)}
                                />
                                <label className="form-label ms-2 cursor-pointer" onClick={() => setPrivPolModal(true)}>
                                    <Trans>I agree with the privacy policy and consent to the processing of personal data</Trans>
                                </label>
                            </div>
                        </div>
                        <div className='mb-3 row justify-content-center'>
                            <div className="col-6 col-md-2">
                                <button
                                    type="button"
                                    className="btn btn-primary w-100"
                                    onClick={() => registration()}
                                ><Trans>Register</Trans></button>
                            </div>
                        </div>
                    </form>
                }</>}
        <ModalPopoverRightTop
            toggle={langToggle}
            setToggle={setLangToggle}
            title={store.lang === 'ba' ? 'Телде һайлағыҙ' : store.lang === 'ru' ? 'Выберите язык' : 'Сhoose the language'}
            modalContent={<Lang />}
            clickedButtonOne={() => { }}
            clickedButtonTwo={() => setLangToggle(false)}
            ButtonOneValue=''
            ButtonTwoValue=''
        />
        <PrivPolModal toggle={privPolModal} setToggle={setPrivPolModal} />
    </>
    )
};
export default observer(LoginForm);